export default __webpack_public_path__ + "static/media/do.0ee1f2dd.png";